import React, { useEffect, useState, useMemo } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { toast } from "react-toastify";
import api from "../../api/api";
import "./address.css";
import { GoogleMap, MarkerF } from "@react-google-maps/api";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Loader from "../loader/Loader";
import {
  setAddress,
  setSelectedAddress,
} from "../../model/reducer/addressReducer";
import { BiCurrentLocation } from "react-icons/bi";

const NewAddress = (props) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const address = useSelector((state) => state.address);
  const city = useSelector((state) => state.city);

  const [addressDetails, setaddressDetails] = useState({
    name: props.name || "",
    mobile_num: props.mobile || "",
    alternate_mobile_num: "",
    floor: "",
    address: "",
    city: "",
    pincode: "",
    address_type: "Home",
    is_default: false,
  });

  const handleConfirmAddress = () => {
    props.setisLoader(true);
    const lat = center.lat;
    const lng = center.lng;

    const commonSuccessHandler = (res, resultOnUpdate = null) => {
      if (res.status === 1) {
        dispatch(setAddress({ data: res.data }));
        const defaultAddress = res.data.find(
          (element) => element.is_default == 1
        );
        if (defaultAddress) {
          dispatch(setSelectedAddress({ data: defaultAddress }));
        }
      } else {
        toast.error(res.message || "Failed to refresh addresses.");
      }
      props.setshow(false); // Close modal only on complete success
    };

    const commonErrorHandler = (error) => {
      console.error("Address operation failed:", error);
      toast.error(
        error.message || "An unexpected error occurred. Please try again."
      );
    };

    if (!props.isAddressSelected) {
      // Add a new address
      api
        .addAddress(
          user?.jwtToken,
          addressDetails.name,
          addressDetails.mobile_num,
          addressDetails.address_type,
          addressDetails.address,
          addressDetails.floor,
          addressDetails.pincode,
          addressDetails.city,
          addressDetails.alternate_mobile_num,
          lat,
          lng,
          addressDetails.is_default
        )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 1) {
            toast.success("Successfully Added Address!");
            setaddressDetails({
              // Reset form
              name: "",
              mobile_num: "",
              alternate_mobile_num: "",
              address: "",
              city: "",
              pincode: "",
              floor: "",
              address_type: "Home",
              is_default: false,
            });
            // Refresh address list
            return api
              .getAddress(user?.jwtToken)
              .then((resp) => resp.json())
              .then(commonSuccessHandler)
              .catch(commonErrorHandler);
          } else {
            throw new Error(result.message || "Failed to add address.");
          }
        })
        .catch(commonErrorHandler)
        .finally(() => props.setisLoader(false));
    } else {
      // Update an existing address
      api
        .updateAddress(
          user?.jwtToken,
          address.selected_address.id,
          addressDetails.name,
          addressDetails.mobile_num,
          addressDetails.address_type,
          addressDetails.address,
          addressDetails.floor,
          addressDetails.pincode,
          addressDetails.city,
          addressDetails.alternate_mobile_num,
          lat,
          lng,
          addressDetails.is_default
        )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 1) {
            toast.success("Successfully Updated Address!");
            props.setIsAddressSelected(false);
            setaddressDetails({
              // Reset form
              name: "",
              mobile_num: "",
              alternate_mobile_num: "",
              address: "",
              floor: "",
              city: "",
              pincode: "",
              address_type: "Home",
              is_default: false,
            });
            setisconfirmAddress(false);
            // Refresh address list
            return api
              .getAddress(user?.jwtToken)
              .then((resp) => resp.json())
              .then((res) => commonSuccessHandler(res, result)) // Pass original result for context if needed
              .catch(commonErrorHandler);
          } else {
            throw new Error(result.message || "Failed to update address.");
          }
        })
        .catch(commonErrorHandler)
        .finally(() => props.setisLoader(false));
    }
  };

  useEffect(() => {
    if (props.isAddressSelected && address.selected_address) {
      setaddressDetails({
        name: address.selected_address.name,
        mobile_num: address.selected_address.mobile,
        alternate_mobile_num: address.selected_address.alternate_mobile,
        address: address.selected_address.address,
        floor: address.selected_address.floor,
        city: address.selected_address.city,
        pincode: address.selected_address.pincode,
        address_type: address.selected_address.type,
        is_default: address.selected_address.is_default === 1 ? true : false,
      });
      // Set map to the selected address location
      setlocalLocation({
        lat: parseFloat(address.selected_address.latitude),
        lng: parseFloat(address.selected_address.longitude),
      });
    } else {
      // Reset form and set map to default city location
      setaddressDetails({
        name: props.name || "",
        mobile_num: props.mobile || "",
        alternate_mobile_num: "",
        floor: "",
        address: "",
        city: "",
        pincode: "",
        address_type: "Home",
        is_default: false,
      });
      setlocalLocation({
        lat: parseFloat(city.city ? city.city.latitude : 0),
        lng: parseFloat(city.city ? city.city.longitude : 0),
      });
    }
  }, [props.isAddressSelected, address?.selected_address, city.city]);

  const [isconfirmAddress, setisconfirmAddress] = useState(false);
  const [localLocation, setlocalLocation] = useState({
    lat: parseFloat(city.city ? city.city.latitude : 0),
    lng: parseFloat(city.city ? city.city.longitude : 0),
  });
  const [addressLoading, setaddressLoading] = useState(false);
  const center = useMemo(
    () => ({
      lat: localLocation.lat,
      lng: localLocation.lng,
    }),
    [localLocation.lat, localLocation.lng]
  );

  useEffect(() => {
    if (addressDetails.address && addressDetails.city) {
      const geocoder = new window.google.maps.Geocoder();
      const fullAddress = `${addressDetails.address}, ${addressDetails.city}, ${addressDetails.pincode}`;
      geocoder.geocode({ address: fullAddress }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          setlocalLocation({ lat: location.lat(), lng: location.lng() });
        } else {
          console.error(
            "Geocode was not successful for the following reason:",
            status
          );
        }
      });
    }
  }, [addressDetails.address, addressDetails.city, addressDetails.pincode]);

  const onMarkerDragStart = () => {
    setaddressLoading(true);
  };

  const onMarkerDragEnd = (e) => {
    const newLatLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    const geocoder = new window.google.maps.Geocoder();

    geocoder
      .geocode({ location: newLatLng })
      .then((response) => {
        if (response.results[0]) {
          setlocalLocation({
            lat: parseFloat(response.results[0].geometry.location.lat()),
            lng: parseFloat(response.results[0].geometry.location.lng()),
          });

          let address = "",
            pincode = "",
            city = "";
          response.results[0].address_components.forEach((res_add) => {
            if (
              res_add.types.includes("route") ||
              res_add.types.includes("premise")
            ) {
              address = res_add.long_name;
            }
            if (res_add.types.includes("sublocality_level_1")) {
              address += ", " + res_add.long_name;
            }
            if (res_add.types.includes("postal_code")) {
              pincode = res_add.long_name;
            }
            if (res_add.types.includes("locality")) {
              city = res_add.long_name;
            }
          });

          setaddressDetails((state) => ({ ...state, address, city, pincode }));
        } else {
          toast.error("Could not determine address from this location.");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Geocoder failed due to: " + error);
      })
      .finally(() => setaddressLoading(false));
  };
  const { t } = useTranslation();

  const mapContainerStyle = {
    width: "100%",
    height: window.innerWidth > 990 ? "100%" : "400px",
  };
  const handleCurrentLocationClick = () => {
    if (!("geolocation" in navigator)) {
      toast.error("Geolocation is not supported by your browser.");
      return;
    }
    setaddressLoading(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latLng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        onMarkerDragEnd({
          latLng: { lat: () => latLng.lat, lng: () => latLng.lng },
        });
      },
      (error) => {
        toast.error(
          "Could not get current location. Please enable location services."
        );
        setaddressLoading(false);
      }
    );
  };

  return (
    <>
      <Modal
        className="new-address"
        show={props.show}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header>
          <div className="d-flex flex-row justify-content-between header w-100 align-items-center">
            <h5>{t("new_address")}</h5>
            {props.fromLogin == false && (
              <button
                type="button"
                className=""
                onClick={() => {
                  props.setshow(false);
                  props.setIsAddressSelected(false);
                }}
                style={{ width: "30px" }}
              >
                <AiOutlineCloseCircle />
              </button>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="flex d-lg-flex flex-row gap-5">
            <div className="w-100 mapWrapper">
              <button
                className="current-location-button"
                onClick={handleCurrentLocationClick}
              >
                <BiCurrentLocation
                  className="mx-3"
                  width="40px"
                  height="40px"
                />
              </button>
              <GoogleMap
                zoom={14}
                center={center}
                mapContainerStyle={mapContainerStyle}
                className="map-marker"
              >
                <MarkerF
                  position={center}
                  draggable={true}
                  onDragStart={onMarkerDragStart}
                  onDragEnd={onMarkerDragEnd}
                ></MarkerF>
              </GoogleMap>
            </div>

            {addressLoading ? (
              <div className="d-flex justify-content-center w-100">
                <Loader width="100%" height="675px" />
              </div>
            ) : (
              <div className="w-100">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleConfirmAddress();
                  }}
                  className="address-details-wrapper"
                >
                  <div className="contact-detail-container">
                    <h3>{t("contact_details")}</h3>
                    <div className="contact-details">
                      <input
                        type="text"
                        style={{ width: "100%" }}
                        placeholder={t("Name")}
                        value={addressDetails.name}
                        required
                        onChange={(e) => {
                          setaddressDetails((state) => ({
                            ...state,
                            name: e.target.value,
                          }));
                        }}
                      ></input>
                      <input
                        required
                        type="text"
                        style={{ width: "100%" }}
                        placeholder={t("mobile_number")}
                        value={addressDetails.mobile_num}
                        onChange={(e) => {
                          setaddressDetails((state) => ({
                            ...state,
                            mobile_num: e.target.value,
                          }));
                        }}
                      />
                      <input
                        type="text"
                        style={{ width: "100%" }}
                        placeholder={t("alt_mobile_no")}
                        value={addressDetails.alternate_mobile_num}
                        onChange={(e) => {
                          setaddressDetails((state) => ({
                            ...state,
                            alternate_mobile_num: e.target.value,
                          }));
                        }}
                      ></input>
                    </div>
                  </div>

                  <div className="address-detail-container">
                    <h3>{t("address_details")}</h3>
                    <div className="address-details">
                      <input
                        type="text"
                        style={{ width: "100%" }}
                        placeholder={t("address")}
                        value={addressDetails.address}
                        onChange={(e) => {
                          setaddressDetails((state) => ({
                            ...state,
                            address: e.target.value,
                          }));
                        }}
                        required
                      ></input>
                      <input
                        type="text"
                        style={{ width: "100%" }}
                        placeholder={t("floor_apartment_etc")}
                        value={addressDetails.floor}
                        onChange={(e) => {
                          setaddressDetails((state) => ({
                            ...state,
                            floor: e.target.value,
                          }));
                        }}
                      ></input>
                      <input
                        type="text"
                        style={{ width: "100%" }}
                        placeholder={t("enter_pincode")}
                        value={addressDetails.pincode}
                        onChange={(e) => {
                          setaddressDetails((state) => ({
                            ...state,
                            pincode: e.target.value,
                          }));
                        }}
                        required
                      ></input>
                      <input
                        type="text"
                        className=""
                        style={{ width: "100%" }}
                        required
                        value={addressDetails.city}
                        placeholder={t("enter_city")}
                        onChange={(e) =>
                          setaddressDetails((state) => ({
                            ...state,
                            city: e.target.value,
                          }))
                        }
                      ></input>
                    </div>
                  </div>

                  <div className="address-type-container">
                    <h3>{t("address_type")}</h3>
                    <div className="address-type">
                      <input
                        type="radio"
                        name="address-type"
                        id="home-address"
                        onChange={() => {
                          setaddressDetails((state) => ({
                            ...state,
                            address_type: "Home",
                          }));
                        }}
                        autoComplete="off"
                        checked={addressDetails.address_type === "Home"}
                      />
                      <label htmlFor="home-address">
                        {t("adress_type_home")}
                      </label>

                      <input
                        type="radio"
                        name="address-type"
                        id="office-address"
                        onChange={() => {
                          setaddressDetails((state) => ({
                            ...state,
                            address_type: "Office",
                          }));
                        }}
                        autoComplete="off"
                        checked={addressDetails.address_type === "Office"}
                      />
                      <label htmlFor="office-address">
                        {t("address_type_office")}
                      </label>

                      <input
                        type="radio"
                        name="address-type"
                        id="other-address"
                        onChange={() => {
                          setaddressDetails((state) => ({
                            ...state,
                            address_type: "Other",
                          }));
                        }}
                        autoComplete="off"
                        checked={addressDetails.address_type === "Other"}
                      />
                      <label htmlFor="other-address">
                        {t("address_type_other")}
                      </label>
                    </div>
                    <div className="default-address">
                      <input
                        type="checkbox"
                        className="mx-2"
                        onChange={() => {
                          setaddressDetails((state) => ({
                            ...state,
                            is_default: !addressDetails.is_default,
                          }));
                        }}
                        checked={addressDetails.is_default}
                      />
                      {t("set_as_default_address")}
                    </div>
                  </div>

                  <button type="submit" className="confirm-address">
                    {t("confirm_location")}
                  </button>
                </form>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NewAddress;
